import { Injectable } from '@angular/core';
import { Criteria } from '@daas-consulting/core-cross-interfaces';
import {
  AuditModel,
  Filter,
} from '@daas-consulting/security/audit/frontend/models';
import * as store from '@daas-consulting/security/audit/frontend/store';
import { AuditDetailPageViewContract } from '@daas-consulting/security/audit/frontend/view_contracts';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Injectable()
export class AuditDetailPageViewModel implements AuditDetailPageViewContract {
  @Select(store.selectors.AuditDetailPreviewSelectors.item)
  item$!: Observable<AuditModel>;

  @Select(store.selectors.AuditDetailPreviewSelectors.items)
  items$!: Observable<AuditModel[]>;

  @Select(store.selectors.AuditDetailPreviewSelectors.detail)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detail$!: Observable<any>;

  @Select(store.selectors.AuditDetailPreviewSelectors.hasDetail)
  hasDetail$!: Observable<boolean>;

  @Select(store.selectors.AuditDetailPreviewSelectors.activeDetail)
  activeDetail$!: Observable<number>;

  activeFilters$!: Observable<Criteria[]>;
  filter$!: Observable<Filter>;
  loadItemSuccessful$!: Observable<void>;

  readonly #store: Store;

  constructor(store: Store) {
    this.#store = store;
  }

  load($event: AuditModel): void {
    const action = new store.actions.GetItem({
      entity: $event.entity as string,
      entityId: $event.entityId as string,
    });
    this.#store.dispatch(action);
  }

  loadHistory($event: AuditModel): void {
    const action = new store.actions.GetHistory({
      entity: $event.entity as string,
      entityId: $event.entityId as string,
    });
    this.#store.dispatch(action);
  }

  loadDetail($event: AuditModel): void {
    const action = new store.actions.GetDetail({
      entity: $event.entity as string,
      entityId: $event.entityId as string,
      seq: $event.seq,
    });
    this.#store.dispatch(action);
  }

  reset(): void {
    const action = new store.actions.Reset();
    this.#store.dispatch(action);
  }
}
